import api from "./api";

export const fetchPartnerPayouts =
    async (
        partnerId,
        page = 1,
        size = 10
    ) => {
        try {
            const response =
                await api.get(
                    `/driver-partner-payout-management/partner/${partnerId}?page=${page}&size=${size}`
                );

            return {
                success: true,
                data:
                    response.data
                        .data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error
                        .response
                        ?.data
                        ?.detail ||
                    error.message,
            };
        }
    };